<div class="table-responsive margin-top-15 table-view">
  <h5 class="table-title">Observation Type</h5>
  <button [disabled]="DisableExport"
    class="btn btn-primary primary-btn button-excel"
    style="margin-bottom: 10px"
    (click)="exportToExcel()"
  >
    <i class="fa fa-file-excel-o"></i>Export To Excel
  </button>
  <p-table
    [value]="ObservationTypeData"
    [scrollable]="false"
    scrollHeight="500px"
    dataKey="Id"
    editMode="row"
    id="ObservationTypesTableToExport"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 160px">Unit</th>
        <th class="center-table" style="width: 100px">Conversation</th>
        <th class="center-table" style="width: 100px">Safe</th>
        <th class="center-table" style="width: 100px">Act</th>
        <th class="center-table" style="width: 100px">Observation</th>
        <th class="center-table" style="width: 100px">Unsafe</th>
        <th class="center-table" style="width: 100px">Condition</th>
        <th class="center-table" style="width: 100px">Actions</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-ObsData
      let-editing="editing"
      let-ri="rowIndex"
    >
      <tr [pEditableRow]="ObsData">
        <td style="width: 260px">
          {{ ObsData.category }}
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ObsData.Conversation"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObservationTypeSelectedDetails(
                    ObsData.UnitId,
                    ObsData.category,
                    1
                  )
                "
                data-target="#AT"
                >{{ ObsData.Conversation }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ObsData.Safe"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObservationTypeSelectedDetails(
                    ObsData.UnitId,
                    ObsData.category,
                    2
                  )
                "
                data-target="#AT"
                >{{ ObsData.Safe }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ObsData.Act"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObservationTypeSelectedDetails(
                    ObsData.UnitId,
                    ObsData.category,
                    3
                  )
                "
                data-target="#AT"
              >
                {{ ObsData.Act }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ObsData.Observation"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObservationTypeSelectedDetails(
                    ObsData.UnitId,
                    ObsData.category,
                    4
                  )
                "
                data-target="#AT"
              >
                {{ ObsData.Observation }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ObsData.Unsafe"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObservationTypeSelectedDetails(
                    ObsData.UnitId,
                    ObsData.category,
                    5
                  )
                "
                data-target="#AT"
              >
                {{ ObsData.Unsafe }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input
                pInputText
                type="number"
                [(ngModel)]="ObsData.Condition"
                required
              />
            </ng-template>
            <ng-template pTemplate="output">
              <a
                data-toggle="modal"
                pTooltip="Get Details"
                tooltipPosition="top"
                (click)="
                  GetObservationTypeSelectedDetails(
                    ObsData.UnitId,
                    ObsData.category,
                    6
                  )
                "
                data-target="#AT"
              >
                {{ ObsData.Condition }}</a
              >
            </ng-template>
          </p-cellEditor>
        </td>
        <td class="center-table" *ngIf="ObsData.category != 'Total'">
          <button
            *ngIf="!editing"
            pButton
            pRipple
            type="button"
            pInitEditableRow
            icon="pi pi-pencil"
            (click)="onRowEditInit(ObsData)"
            class="p-button-rounded p-button-text"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pSaveEditableRow
            icon="pi pi-check"
            (click)="onRowEditSave(ObsData)"
            class="p-button-rounded p-button-text p-button-success p-mr-2"
          ></button>
          <button
            *ngIf="editing"
            pButton
            pRipple
            type="button"
            pCancelEditableRow
            icon="pi pi-times"
            (click)="onRowEditCancel(ObsData, ri)"
            class="p-button-rounded p-button-text p-button-danger"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div
  class="modal fade PDModal"
  data-backdrop="static"
  style="opacity: 1 !important"
  id="AT"
  role="dialog"
>
  <div class="modal-dialog custom-modal">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close button-cancel" data-dismiss="modal">
          &times;
        </button>
        <!-- <h4 class="modal-title custom_align" id="Heading">Risk Assessment Matrix</h4> -->
      </div>
      <div class="modal-body">
        <!-- <img class="ram-img" src="assets/images/incident-ram.png" /> -->
        <ol id="liPDheight">
          <ng-container *ngFor="let item of ObsTyData; let i = index">
            <li>
              <a (click)="Redirect(item.value, item.ID)">{{ item.Text }}</a>
            </li>
          </ng-container>
        </ol>
        <span *ngIf="ObsTyData?.length < 1" style="color: red"
          >No Records Found..</span
        >
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</div>
